<button
  type="button"
  class="add-tile"
  data-dgat="addTile-5e9"
  (click)="onClick()"
>
  <df-icon
    class="color-blue guts-m-r-half"
    icon="plus-circle"
    size="medium"
  ></df-icon>
  <strong class="color-blue">
    {{ label ?? 'FlexSvc_AddResources' | translate }}
  </strong>
</button>
